export const useIsProduction = () => {
  return process.env.REACT_APP_DEVELOPMENT_MODE !== 'true';
};
